<template>
    <div class="product-insights">
      <carousel :per-page="4" :navigationEnabled="true" :mouse-drag="false">
        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Total Product Intraction Time:</h3>
                <h2 style="text-align: left;font-size: 16px;">{{ productTotalTimeMinutes / 60}} Hr</h2>
              </div>
            </div>
          </div>
        </slide>
        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Avg Product Intraction Time:</h3>
                <h2 style="text-align: left;font-size: 16px;">{{ productAvgEngagementMinutes }} Minutes</h2>
              </div>
              </div>
            </div>
        </slide>
        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Lowest Product Intraction:</h3>
                <h2 style="text-align: left;font-size: 16px;">{{ productFastestActivityMinutes }} Minutes</h2>
              </div>
              </div>
            </div>
        </slide>
        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Maximum Product Intraction:</h3>
                <h2 style="text-align: left;font-size: 16px;">{{ productSlowestActivityminutes }} Minutes</h2>
              </div>
              </div>
            </div>
        </slide>

      </carousel>
      <!-- <h4 v-show="loading" style="text-align: center;">Loading Products Insights...</h4> -->
    </div>

</template>
<script>
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'ProductInsights',
  components: {
    Carousel,
    Slide
  },
  props: ['brandId', 'productTotalTimeMinutes', 'productAvgEngagementMinutes', 'productFastestActivityMinutes', 'productSlowestActivityminutes'],
  data: function () {
    return {
      loading: true,
      localTime: '',
      selfies: [],
      image: '',
      userName: '',
      storeName: '',
      storeAddress: '',
      slickOptions: {
        slidesToShow: 3
      }
    }
  },
  methods: {
    next () {
      this.$refs.slick.next()
    },

    prev () {
      this.$refs.slick.prev()
    },

    reInit () {
      this.$nextTick(() => {
        this.$refs.slick.reSlick()
      })
    },

    handleAfterChange (event, slick, currentSlide) {
      console.log('handleAfterChange', event, slick, currentSlide)
    },
    handleBeforeChange (event, slick, currentSlide, nextSlide) {
      console.log('handleBeforeChange', event, slick, currentSlide, nextSlide)
    },
    handleBreakpoint (event, slick, breakpoint) {
      console.log('handleBreakpoint', event, slick, breakpoint)
    },
    handleDestroy (event, slick) {
      console.log('handleDestroy', event, slick)
    },
    handleEdge (event, slick, direction) {
      console.log('handleEdge', event, slick, direction)
    },
    handleInit (event, slick) {
      console.log('handleInit', event, slick)
    },
    handleReInit (event, slick) {
      console.log('handleReInit', event, slick)
    },
    handleSetPosition (event, slick) {
      console.log('handleSetPosition', event, slick)
    },
    handleSwipe (event, slick, direction) {
      console.log('handleSwipe', event, slick, direction)
    },
    handleLazyLoaded (event, slick, image, imageSource) {
      console.log('handleLazyLoaded', event, slick, image, imageSource)
    },
    handleLazyLoadError (event, slick, image, imageSource) {
      console.log('handleLazeLoadError', event, slick, image, imageSource)
    }
  },
  mounted () {
    // this.getBrandSocialSelfies()

  },
  watch: {
  }
}
</script>
<style>
.VueCarousel-pagination{
  display: none;
}
.metrics-box {
    width: 94%;
    margin: 10px 3%;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.4);
    padding: 10px;
    text-align: center;
}
.metrics-box h3{
    font-size: 14px;
    color: #000;
    line-height: 23px;
}
.metrics-box h2{
    font-size: 20px;
    color: #000;
    line-height: 23px;
    min-height: 23px;
}
</style>
